import {useEffect, useState} from 'react';
import * as Sentry from '@sentry/nextjs';

import {useUpdateSubscriptionMutation} from '#apollo/schema';
import {Link} from '#component/base';
import {Button, Text, UncertainProgress} from '#component/base';
import {Modal, ModalRoot} from '#component/base/Modal';
import {CONTACT_URL} from '#constant/app';
import {useToastQueue} from '#hook';
import {Colors} from '#theme';

import {container, progressContainer, title} from './ReactivateSubscriptionButton.css';

export const ReactivateSubscriptionButton = ({textColor}: {textColor: Colors}) => {
  const [open, setOpen] = useState(false);
  const [updateSubscription, {loading: reactivatingSubscription}] = useUpdateSubscriptionMutation({
    refetchQueries: [
      'ManagePlanQuery',
      'PauseSubscriptionQuery',
      'ProfileCustomerSubscriptionQuery',
    ],
  });
  const {addToast} = useToastQueue();

  const handleReactivateSubscription = async () => {
    try {
      await updateSubscription({
        variables: {subscriptionChanges: {updateStatusTo: 'ACTIVE'}},
      });
    } catch (error) {
      addToast({
        children: (
          <>
            Failed to reactive your subscription, please contact{' '}
            <Link href={CONTACT_URL} variant="burgundy">
              {CONTACT_URL}
            </Link>{' '}
            if the issue persists
          </>
        ),
      });
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    setOpen(reactivatingSubscription);
  }, [reactivatingSubscription]);

  return (
    <>
      {open && (
        <ModalRoot open={open}>
          <Modal layout="drawer" variant="light" hideCloseButton={false}>
            <div className={container}>
              <div>
                <Text as="h3" variant="heading3" color="burgundy" className={title}>
                  Reactivating Subscription
                </Text>
              </div>
            </div>
            <div className={progressContainer}>
              <UncertainProgress width={144} size={24} duration={1} />
            </div>
          </Modal>
        </ModalRoot>
      )}
      <Button variant="primary" color={textColor} onClick={handleReactivateSubscription}>
        Reactivate
      </Button>
    </>
  );
};
